import axios from 'axios';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { FormElement } from '@/models/FormElement';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
@Module({ namespaced: true })
class FormElementModule extends VuexModule {
    @Action
    async read(url: string) {
        try {
            const r: any = await axios({
                method: 'GET',
                url,
            });
            return new FormElement(r.data);
        } catch (e) {
            return e;
        }
    }

    @Action
    async create(data: FormElement) {
        try {
            const r: any = await axios({
                method: 'POST',
                url: '/api/form_elements',
                data,
            });

            if (r.status !== 201) {
                throw Error('FormElement CREATE failed.');
            }
            return new FormElement(r.data);
        } catch (e) {
            return e;
        }
    }

    @Action
    async update(data: FormElement) {
        try {
            const r: any = await axios({
                method: 'PUT',
                url: `/api/form_elements/${data.id}`,
                responseType: 'json',
                headers: {
                    'accept': 'application/ld+json',
                    'content-type': 'application/ld+json',
                },
                data,
            });

            if (r.status !== 200) {
                throw Error('FormElement UPDATE failed.');
            }

            return new FormElement(r.data);
        } catch (e) {
            return e;
        }
    }

    @Action
    async delete(data: FormElement) {
        try {
            const r: any = await axios({
                method: 'DELETE',
                url: `/api/form_elements/${data.id}`,
            });

            if (r.status !== 204) {
                throw Error('FormELement DELETE failed.');
            }
        } catch (e) {
            return e;
        }
    }
}

export default FormElementModule;
